import React, { useEffect, useId, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n/LanguageContext";
import "./CookieBanner.scss";

const CONSENT_KEY = "pontepie_cookie_consent";

export function CookieBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const acceptRef = useRef<HTMLButtonElement>(null);
  const titleId = useId();

  useEffect(() => {
    try {
      setVisible(localStorage.getItem(CONSENT_KEY) !== "accepted");
    } catch {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    if (!visible || leaving) return;
    acceptRef.current?.focus();
  }, [visible, leaving]);

  const accept = () => {
    try {
      localStorage.setItem(CONSENT_KEY, "accepted");
    } catch {
      /* ignore */
    }
    const reduceMotion =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) {
      setVisible(false);
      return;
    }
    setLeaving(true);
  };

  const onExitEnd = () => {
    if (leaving) setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className={`cookie-banner${leaving ? " is-leaving" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      onTransitionEnd={onExitEnd}
    >
      <div className="cookie-banner__inner">
        <p id={titleId} className="cookie-banner__text">
          {t("cookieBanner.message")}{" "}
          <Link className="cookie-banner__link" to="/cookies">
            {t("cookieBanner.policy")}
          </Link>
          .
        </p>
        <button
          ref={acceptRef}
          type="button"
          className="cookie-banner__btn"
          onClick={accept}
        >
          {t("cookieBanner.accept")}
        </button>
      </div>
    </div>
  );
}
